import { select, selectAll, on, getModuleOptions, getAttribute } from 'modules/dom'
import { addQueryVar } from 'modules/utils'

const MODULE_NAME = 'search-webinars'
const SELECT_FIELD_SELECTOR = '.js-select'
const SEARCH_FIELD_SELECTOR = '.js-search'
const SUBMIT_BUTTON_SELECTOR = '.js-submit'

export default el => {
  const selectEls = selectAll(SELECT_FIELD_SELECTOR, el)
  const searchEl = select(SEARCH_FIELD_SELECTOR, el)
  const submitButtonEl = select(SUBMIT_BUTTON_SELECTOR, el)
  const options = getModuleOptions(MODULE_NAME, el)
  let filterUrl = ''

  const handleSearchEl = () => {
    if (searchEl) {
      const value = searchEl.value
      const name = getAttribute('name', searchEl)
      filterUrl = addQueryVar(name, value, filterUrl)
    }
  }

  const handleSelectGAEvents = () => {
    if (selectEls.length) {
      selectEls.map(select => {
        on('change', () => {
          const label = select.options[0].text
          const selectedText = select.options[select.selectedIndex].text
          if (typeof gtag !== 'undefined' && label && selectedText) {
            gtag('event', `Select ${label}`, {
              event_category: 'Resources Search',
              event_label: selectedText
            })
          }
        }, select)
      })
    }
  }

  const handleSelect = () => {
    if (selectEls.length) {
      selectEls.map(select => {
        const value = select.value
        const name = getAttribute('name', select)
        const filterType = getAttribute('data-filter-type', select)
        if (filterType === 'term_link') {
          if (filterUrl.indexOf('?') > -1) {
            filterUrl = value + filterUrl.substring(filterUrl.indexOf('?'))
          } else {
            filterUrl = value
          }
        } else {
          filterUrl = addQueryVar(name, value, filterUrl)
        }
      })
    }
  }

  const redirect = () => {
    if (filterUrl) {
      const part = (filterUrl.indexOf('?') === 0 && filterUrl.indexOf('type') > -1) ?
        'resources' :
        ''
      /**
       * Add base url
       * @type {string}
       */
      let url = `${options.baseUrl}${part}${filterUrl}`
      /**
       * replace '?search=' to '?s=" with only one param
       * @type {string}
       */
      url = (url.indexOf('&') === -1) ? url.replace('?search=', '?s=') : url
      /**
       * Attach GA event
       */
      if (typeof gtag !== 'undefined') {
        gtag('event', 'Click Search Button', {
          'event_category': 'Resources Search',
          'event_label': `${part}${filterUrl}`
        })
      }
      /**
       * Redirect
       * @type {string}
       */
      window.location.href = url
    }
  }

  on('click', (e) => {
    e.preventDefault()
    handleSelect()
    handleSearchEl()
    redirect()
  }, submitButtonEl)

  handleSelectGAEvents()
}
